import { AccountConversationsSidebarPanel } from 'components/shared/AccountConversationsSidebarPanel'
import { PortfolioSidebarPanel } from 'components/holdings/PortfolioSidebarPanel'
import { TransactionHistorySidebarPanel } from 'components/accounts/TransactionHistorySidebarPanel'
import React, { Fragment } from 'react'

const AccountSidebar: React.FC<{ accountId: string; expanded: string; setExpanded: (panel: string) => void }> = ({
  accountId,
  expanded,
  setExpanded,
}) => {
  const handleChange = (panel: string) => (_event: React.ChangeEvent<{}>, isPanelExpanded: boolean) => {
    if (isPanelExpanded) {
      setExpanded(panel)
    } else {
      setExpanded('')
    }
  }
  return (
    <Fragment>
      <TransactionHistorySidebarPanel
        expanded={expanded === 'transaction-history'}
        onChange={handleChange('transaction-history')}
        accountId={accountId}
      />
      <PortfolioSidebarPanel
        expanded={expanded === 'portfolio'}
        onChange={handleChange('portfolio')}
        accountId={accountId}
      />
      <AccountConversationsSidebarPanel
        expanded={expanded === 'conversations'}
        onChange={handleChange('conversations')}
        accountId={accountId}
        currentPage="account"
      />
    </Fragment>
  )
}

export { AccountSidebar }
